import React, { Component,useState } from "react";
import Clock from "./Clock";

export default function Count (props) {

  const [ deadline , setDeadline ] = useState(props.days);

  return(
    <>
    <Clock deadline={deadline} />
    </>
  )
}
